"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Auth = function Auth($q, $state) {
  "ngInject";

  var service = this;

  service.responseError = function (response) {
    if (response.status == 401) {
      // window.location = "/login";
      $state.go("login");
    }
    return $q.reject(response);
  };
};
exports.default = Auth;


// WEBPACK FOOTER //
// ./client/app/services/authService/auth.service.js